<template>
  <div class="employeeDetail positionr" v-loading="loading">
    <!-- 面包屑导航区 -->
    <el-breadcrumb>
      <el-breadcrumb-item class="pointer" :to="{ path: '/employeemangent' }"
        >人员管理</el-breadcrumb-item
      >
      <el-breadcrumb-item>人员管理详情</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 头像更换 -->
    <!-- <div class="avatar-uploader positiona">
      <el-upload
        action="http://120.55.60.66:8001/upload/uploadImage"
        :show-file-list="false"
        :limit="1"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload"
      >
        <img
          :src="imageUrl"
          class="avatar"
          onerror="this.src='https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=2100401123,2895311668&fm=26&gp=0.jpg'"
        />
      </el-upload>
    </div> -->

    <!-- 内容主体 -->
    <div class="bgwhite bort">
      <el-row>
        <!-- tabbar -->
        <!-- <el-col :span="3">
          <div id="navigation">
            <ul>
              <li
                class="menu-item text-cut"
                v-for="(item, i) in tabs"
                :key="item"
                :class="seeThis == i ? 'active' : ''"
              >
                <a href="javascript:void(0)" @click="goAnchor(i)">{{ item }}</a>
              </li>
            </ul>
          </div>
        </el-col> -->
        <!-- tabbar对应内容 -->
        <!-- <el-col :span="24"> -->
        <div class="menu-content">
          <!-- 基本信息 -->
          <div class="p1" id="a1">
            <div class="header-search">
              <div class="title">
                <el-row>
                  <el-col :span="12">
                    <span class="line"></span>
                    基本信息
                  </el-col>
                  <el-col :span="12">
                    <div class="flex align-center justify-end h50">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="保存基本信息和扩展属性"
                        placement="bottom"
                      >
                        <el-button
                          type="primary"
                          size="small"
                          @click="submitForm('ruleForm')"
                          >保存</el-button
                        >
                      </el-tooltip>

                      <el-button
                        plain
                        size="small"
                        @click="route.push('/roleMangent')"
                        >取消</el-button
                      >
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="header-input">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="150px"
                class="ruleForm"
                size="mini"
              >
                <el-row>
                  <el-col :sm="24" :md="24" :lg="12">
                    <el-form-item label="角色名称" prop="roleName">
                      <el-input v-model="ruleForm.roleName"></el-input>
                    </el-form-item>
                  </el-col>
                  <!-- <el-col :sm="24" :md="24" :lg="12">
                    <el-form-item label="密码" prop="password">
                      <el-input v-model="ruleForm.password"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :sm="24" :md="24" :lg="12">
                    <el-form-item label="昵称" prop="nickName">
                      <el-input v-model="ruleForm.nickName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :sm="24" :md="24" :lg="12">
                    <el-form-item label="手机号" prop="phone">
                      <el-input v-model="ruleForm.phone"></el-input>
                    </el-form-item>
                  </el-col> -->
                </el-row>
              </el-form>

              <div style="margin: 40px 0">
<!--                <el-tree-->
<!--                  :data="treeList"-->
<!--                  node-key="id"-->
<!--                  :props="defaultProps"-->
<!--                  ref="tree"-->
<!--                  default-expand-all-->
<!--                  show-checkbox-->
<!--                  :highlight-current="true"-->
<!--                  :check-strictly="true"-->
<!--                  :check-on-click-node="true"-->
<!--                  @check-change="handleCheckChange"-->
<!--                  :default-expanded-keys="[0]"-->
<!--                  :default-checked-keys="defaultKyes"-->
<!--                  :current-node-key="529"-->
<!--                  :filter-node-method="filterNode"-->
<!--                >-->
<!--                </el-tree>-->

                <el-tree
                  :data="treeList"
                  show-checkbox
                  default-expand-all
                  node-key="id"
                  ref="publishNoticeTree"
                  highlight-current
                  :props="defaultProps"
                >
                </el-tree>
              </div>
            </div>
          </div>
        </div>

        <!-- </el-col> -->
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      seeThis: 0,
      tabs: ["基本信息"], //  // "扩展属性",
      // , "与组织的关系", "与岗位的关系", "与权限的关系"
      // "汇报关系",
      ruleForm: {
        roleName: "",
      },
      treeList: [],
      // defaultProps: {
      //   children: "children",
      //   label: "label",
      // },
      rules: {},
      tableData: [],
      id: "",
      userCode: "",
      disabledFalg: false,
      loading: true,
      imageUrl: "",
      userName: "",
      orgTableData: [], //与组织的关系表格数据
      treeData: [], // 组织树形结构数据
      defaultKyes: [], //选中节点
      defaultId: "", //当前节点
      multipleSelection: [],
      defaultProps: {
        children: "childrens",
        label: "name",
      },
    };
  },
  created() {
    if (!this.$route.query.id) {
      this.userCode = this.randomString(11);
      this.disabledFalg = true;
    } else {
      this.userCode = this.$route.query.userCode;
      this.disabledFalg = false;
      this.getDataById();
    }

    // this.userName = JSON.parse(localStorage.getItem("userName"));
    this.getMenuTreeList();
  },
  methods: {
    getMenuTreeList() {
      let that = this;
      // /menuInfo/queryTreeList
      that.$http.post("/menuInfo/queryTreeList", {}).then(function (response) {
        console.log(response.data.data, "-----");
        if (response.data.code == 200) {
          that.$nextTick(() => {
            that.defaultId = response.data.data[1].id;
          });

          that.treeList = [response.data.data[1]];
        }
      });
    },
    // 监听组织数是否选中状态
    handleCheckChange(data, checked) {
      console.log(data, checked);
      // 获取当前节点的所有子节点
      const childNodes = this.getChildrenNodes(data);
      // 如果当前节点被选中，则选中所有子节点，并更新 multipleSelection
      if (checked) {
        this.multipleSelection.push(data); // 添加父节点到选中列表
        childNodes.forEach((child) => {
          this.$refs.tree.setChecked(child.id, true, true); // 设置子节点选中
          this.multipleSelection.push(child); // 添加子节点到选中列表
        });
      } else {
        // 如果当前节点被取消选中，则取消选中所有子节点，并更新 multipleSelection
        this.multipleSelection = this.multipleSelection.filter(
          (item) => item.id !== data.id
        );
        childNodes.forEach((child) => {
          this.$refs.tree.setChecked(child.id, false, true); // 设置子节点取消选中
          this.multipleSelection = this.multipleSelection.filter(
            (item) => item.id !== child.id
          ); // 移除子节点
        });
      }
      // 去重 multipleSelection
      this.multipleSelection = [
        ...new Set(this.multipleSelection.map((item) => item.id)),
      ].map((id) => this.multipleSelection.find((node) => node.id === id));
      console.log(this.multipleSelection, "选中菜单");
    },
    // 递归获取所有子节点
    getChildrenNodes(node) {
      const nodes = [];
      if (node.children && node.children.length > 0) {
        node.children.forEach((child) => {
          nodes.push(child);
          nodes.push(...this.getChildrenNodes(child)); // 递归获取子节点的子节点
        });
      }
      return nodes;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    goAnchor(index) {
      // 也可以用scrollIntoView方法， 但由于这里头部设置了固定定位，所以用了这种方法
      // document.querySelector('#anchor'+index).scrollIntoView()
      this.seeThis = index;
      var i = index + 1;
      var anchor = this.$el.querySelector("#a" + i);
      this.$nextTick(() => {
        this.$el.querySelector(".menu-content").scrollTop = anchor.offsetTop;
      });
    },
    handleScroll() {
      //console.log("滚动了");
      var scrollTop = this.$el.querySelector(".menu-content").scrollTop;
      var scrollHeight = this.$el.querySelector(".menu-content").scrollHeight;
      var height = this.$el.querySelector(".menu-content").offsetHeight;
      var anchorOffset1 = this.$el.querySelector("#a1").offsetTop;
      var anchorOffset2 = this.$el.querySelector("#a2").offsetTop;
      var anchorOffset3 = this.$el.querySelector("#a3").offsetTop;
      var anchorOffset4 = this.$el.querySelector("#a4").offsetTop;
      var anchorOffset5 = this.$el.querySelector("#a5").offsetTop;
      // var anchorOffset6 = this.$el.querySelector("#a6").offsetTop;
      if (scrollTop > anchorOffset1 && scrollTop < anchorOffset2) {
        this.seeThis = 0;
      }
      if (scrollTop > anchorOffset2 && scrollTop < anchorOffset3) {
        this.seeThis = 1;
      }
      if (scrollTop > anchorOffset3 && scrollTop < anchorOffset4) {
        this.seeThis = 2;
      }
      if (scrollTop > anchorOffset4 && scrollTop < anchorOffset5) {
        this.seeThis = 3;
      }
      if (scrollTop > anchorOffset4) {
        this.seeThis = 4;
      }
      if (scrollTop + height == scrollHeight) {
        this.seeThis = 4;
      }
      // if (scrollTop > anchorOffset5 && scrollTop < anchorOffset6) {
      //   this.seeThis = 4;
      // }
      // if (scrollTop > anchorOffset6) {
      //   this.seeThis = 5;
      // }
      // if (scrollTop + height == scrollHeight) {
      //   this.seeThis = 5;
      // }
    },
    // 表单提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var that = this;
          let user = {};
          if (!this.ruleForm.roleName) {
            that.$notify.info({
              title: "提示",
              message: "请填写角色名称",
              showClose: true,
            });
            return;
          }

          if(!that.$refs.publishNoticeTree.getCheckedKeys()){
         return    that.$notify.info({
                  title: "提示",
                  message: "请选择所属菜单",
                  showClose: true,
                });
          }
          // if (this.multipleSelection.length == 0) {
          //   that.$notify.info({
          //     title: "提示",
          //     message: "请选择所属菜单",
          //     showClose: true,
          //   });
          //   return;
          // }
          user = that.ruleForm;

          if (that.id) {
            user.id = that.id;
          }
          let userInfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;
          console.log(userInfo, "-===-=");

          user.merchantCode = userInfo.merchantCode;
          user.merchantName = userInfo.merchantName;
          user.groupCode = userInfo.groupCode;
          user.groupName = userInfo.groupName;

          user.menuInfoList = this.$refs.publishNoticeTree.getCheckedKeys().map(item=>{
            return {id:item}
          })

          console.log(user, "_+_+_+");
          // return;

          // user.creator = that.userName;
          // user.password = that.$md5(user);
          that.$http
            .post("/merchantRole/save", user)
            .then(function (response) {
              if (response.data.code == 200) {
                that.$notify.success({
                  title: "提示",
                  message: "增加成功",
                  showClose: true,
                });
                that.$router.push({
                  path: "/roleMangent",
                });
              } else {
                that.$notify.info({
                  title: "提示",
                  message: response.data.message,
                  showClose: true,
                });
              }
            })
            .catch(function (error) {
              that.$notify.info({
                title: "提示",
                message: "增加失败",
                showClose: true,
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 监听排序
    sortChange() {},

    //头像
    errorHandler() {
      return true;
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },

    // 清空
    empty() {
      this.multipleSelection = [];
      this.$refs.tree.setCheckedKeys([]);
    },
    //删除
    del(id, i) {
      this.$refs.tree.setChecked(id);
      this.multipleSelection.splice(i, 1);
    },

    // 根据id获取用户信息
    getDataById() {
      var that = this;
      that.id = that.$route.query.id;
      console.log(that.id);
      if (that.id != undefined || that.id != "") {
        that.$http
          .post("/merchantRole/queryOne", { id: that.id })
          .then(function (response) {
            //console.log(response.data.data);
            if (response.data.code == 200) {
              that.ruleForm = response.data.data;
              // that.defaultKyes.push(response.data.data[1].id);
              // that.$refs.tree.setCheckedKeys(that.defaultKyes);
              that.$nextTick(() => {
                that.defaultKyes = response.data.data.menuInfoList.map(
                  (item) => {
                    return item.id;
                  }
                );
                that.$refs.publishNoticeTree.setCheckedKeys(that.defaultKyes);
              });
            }
          });
      } else {
      }
    },

    // 获取随机字符串
    randomString(e) {
      e = e || 32;
      var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
        a = t.length,
        n = "";
      for (var i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
      return n;
    },
  },
  mounted() {
    var that = this;
    this.$el.querySelector(".menu-content").onscroll = () => {
      that.handleScroll();
    }; // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
    that.loading = false;
  },
};
</script>

<style lang="less" scope>
.h50 {
  height: 50px;
}

.handle-btn .el-button.add-column-btn {
  width: 100%;
  font-size: 13px;
  background-color: transparent;
  color: #008eff;
  margin-top: -1px;
  position: relative;
  z-index: 100;
}
.employeeDetail {
  .el-breadcrumb__inner {
    color: #2f91df;
  }
  .avatar-uploader {
    top: -16px;
    right: 20px;
    z-index: 10;
  }
  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .el-row {
    #navigation {
      background-color: #f6f7fb;
      font-size: 14px;
      height: calc(100vh - 110px);
      margin-top: -14px;
      li {
        height: 50px;
        line-height: 50px;
        a {
          display: block;
          color: #324059;
          padding-left: 20px;
          background-color: transparent;
        }
      }
      li.active,
      li:hover {
        background-color: #fff;
      }
    }
    .menu-content {
      height: calc(100vh - 110px);
      overflow-y: auto;
      padding-left: 10px;
      padding-right: 5px;
      .p1 {
        margin-bottom: 20px;
      }
      .header-search {
        .title {
          height: 50px;
          line-height: 49px;
          font-size: 15px;
          color: #2f405b;
          padding-left: 10px;
          border-bottom: 1px solid #e3eaf0;
          margin-bottom: 10px;
          .line {
            display: inline-block;
            width: 3px;
            height: 15px;
            background-color: #2f91df;
            margin-right: 5px;
            border-radius: 2px;
            margin-bottom: -2px;
          }
          .el-input {
            width: 247px;
          }
          .el-input .el-input__inner {
            width: 217px;
          }
        }
      }
      .header-input {
        font-size: 13px;
      }
      .model-mask {
        .el-form {
          .el-form-item {
            margin-bottom: 0;
          }
        }
        .el-table {
          margin-top: 10px;
        }
      }
    }
  }
  #selectorOrgDialog .el-dialog {
    width: 600px !important;
  }
  #selectorOrgDialog .selectedUl {
    height: 350px;
    max-height: 350px;
  }
  #selectorOrgDialog .org-selected .selectedUl-box {
    height: 320px !important;
  }
}
</style>
